import { query } from "firebase/firestore";

import getClientsRef from "./getClientsRef";

const getClientsQuery = () => {
  return query(getClientsRef());
}

export default getClientsQuery;
